import { InvoiceAccountType } from '../models/ForwarderAccountAndConfig';
import ForwarderInvoiceBalance from '../models/ForwarderGhaInvoiceBalance';

function reMapAccountBalanceNames(fwdBalance: ForwarderInvoiceBalance): ForwarderInvoiceBalance {

  const fb: ForwarderInvoiceBalance  = { ...fwdBalance };

  switch (fwdBalance.accountType) {
    case 'invoice': fb.accountType = InvoiceAccountType.INVOICE; break;
    case 'prepaid': fb.accountType = InvoiceAccountType.PREPAID; break;
  }

  return fb;
}

function reMapTypeName(type: string): string {

  switch (type) {
    case 'invoice payment': return InvoiceAccountType.INVOICE + ' payment';
    case 'prepaid payment': return InvoiceAccountType.PREPAID + ' payment';
    default: return type;
  }
}

export {
  reMapAccountBalanceNames,
  reMapTypeName
}